export default "__VITE_PUBLIC_ASSET__790bda4b__"